import { useCallback, useRef } from "react";

export const useDebounce = (delay = 300, executeImmediately = true) => {
  // Se 'executeImmediately' for verdadeiro, a primeira chamada não sofre debounce.
  const isInitialCall = useRef(executeImmediately);

  // Ref para armazenar o ID do timeout.
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const debounce = useCallback(
    (func: () => void) => {
      // Na primeira chamada, executa imediatamente.
      if (isInitialCall.current) {
        isInitialCall.current = false;
        func();
        return;
      }

      // Se já houver um timeout agendado, cancela
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }

      // Agenda a execução da função após o delay especificado.
      timeoutRef.current = setTimeout(func, delay);
    },
    [delay]
  );

  return { debounce };
};
